import { render, staticRenderFns } from "./AssessmentPopup.vue?vue&type=template&id=831ce52e&"
import script from "./AssessmentPopup.vue?vue&type=script&lang=js&"
export * from "./AssessmentPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports